import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const OverviewIcon = {
  name: 'OverviewIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "stroke-width": "0px"
      },
      "class": "feather feather-overview"
    }, ctx.data]), [
      h("g", {
        attrs: {
          opacity: "0.7"
        }
      }, [
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6.21875 15.0625C4.71746 15.0625 3.5 16.28 3.5 17.7812C3.5 19.2826 4.71714 20.5 6.21875 20.5C7.72004 20.5 8.9375 19.2825 8.9375 17.7812C8.9375 16.2796 7.72009 15.0625 6.21875 15.0625ZM2 17.7812C2 15.4515 3.88904 13.5625 6.21875 13.5625C8.54841 13.5625 10.4375 15.4511 10.4375 17.7812C10.4375 20.111 8.54846 22 6.21875 22C3.88861 22 2 20.1109 2 17.7812Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M17.7812 15.0625C16.28 15.0625 15.0625 16.28 15.0625 17.7812C15.0625 19.2826 16.2796 20.5 17.7812 20.5C19.2825 20.5 20.5 19.2825 20.5 17.7812C20.5 16.2796 19.2826 15.0625 17.7812 15.0625ZM13.5625 17.7812C13.5625 15.4515 15.4515 13.5625 17.7812 13.5625C20.1109 13.5625 22 15.4511 22 17.7812C22 20.111 20.111 22 17.7812 22C15.4511 22 13.5625 20.1109 13.5625 17.7812Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 3.5C10.4987 3.5 9.28125 4.71746 9.28125 6.21875C9.28125 7.72009 10.4984 8.9375 12 8.9375C13.5013 8.9375 14.7188 7.72004 14.7188 6.21875C14.7188 4.71714 13.5013 3.5 12 3.5ZM7.78125 6.21875C7.78125 3.88904 9.67029 2 12 2C14.3297 2 16.2188 3.88861 16.2188 6.21875C16.2188 8.54846 14.3297 10.4375 12 10.4375C9.66986 10.4375 7.78125 8.54841 7.78125 6.21875Z",
            fill: "currentColor"
          }
        })
      ])
    ]);
  }
};

export default OverviewIcon; 